import React from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SalesPopup } from '../components/SalesPopup';
import { PixelTracker } from '../components/PixelTracker';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { Solution } from '../components/sections/Solution';
import { Modules } from '../components/sections/Modules';
import { Transformation } from '../components/sections/Transformation';
import { Bonuses } from '../components/sections/Bonuses';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQ } from '../components/sections/FAQ';
export function LandingPage() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white" data-id="element-198">
      <PixelTracker data-id="element-199" />
      <CountdownTimer data-id="element-200" />

      <main data-id="element-201">
        <Hero data-id="element-202" />
        <Problem data-id="element-203" />
        <Solution data-id="element-204" />
        <Modules data-id="element-205" />
        <Transformation data-id="element-206" />
        <Bonuses data-id="element-207" />
        <Offer data-id="element-208" />
        <Guarantee data-id="element-209" />
        <Testimonials data-id="element-210" />
        <FAQ data-id="element-211" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-212">
        <p data-id="element-213">
          © {new Date().getFullYear()} MegaPack Dormir Mejor Desde el Amor.
          Todos los derechos reservados.
        </p>
        <p className="mt-2" data-id="element-214">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <SalesPopup data-id="element-215" />
    </div>;
}